import axios from '../axios'

/**
 * 1.4.1 获取合作单位
 * @param programId
 * @returns {Promise | Promise<unknown>}
 */
export const cooperationList = programId => {
  return axios({
    url: `/projectCenter/website/noauth/cooperationList/${programId}`,
    method: 'GET',
    headers: {
      isToken: false
    }
  })
}

/**
 * 1.4.2 获取页签
 * @param programId
 * @returns {Promise | Promise<unknown>}
 */
export const listType = programId => {
  return axios({
    url: `/projectCenter/website/noauth/listType/${programId}`,
    method: 'GET',
    headers: {
      isToken: false
    }
  })
}

/**
 * 1.4.2 获取页签
 * @param pageNo
 * @param pageSize
 * @param programId
 * @returns {Promise | Promise<unknown>}
 */
export const pageSuccess = (pageNo, pageSize, programId) => {
  return axios({
    url: `/projectCenter/website/noauth/pageSuccess/${pageNo}/${pageSize}/${programId}`,
    method: 'GET',
    headers: {
      isToken: false
    }
  })
}

/**
 *
 * @param programId
 * @returns {Promise | Promise<unknown>}
 */
export const listDownload = programId => {
  return axios({
    url: `/projectCenter/website/noauth/listDownload/${programId}`,
    method: 'GET',
    headers: {
      isToken: false
    }
  })
}

/**
 * 1.4.4 获取已配置的项目信息
 * @returns {Promise | Promise<unknown>}
 */
export const programs = () => {
  return axios({
    url: `/projectCenter/website/noauth/findPrograms`,
    method: 'GET',
    headers: {
      isToken: false
    }
  })
}

/**
 * 1.4.5 下载文件
 * @param programId
 * @returns {Promise | Promise<unknown>}
 */
export const downloadFile = (programId, fileId) => {
  return axios({
    url: `/projectCenter/website/downloadFile/${programId}/${fileId}`,
    methos: 'GET'
  })
}



// WEBPACK FOOTER //
// ./src/comm/http/modules/projectCenter.js